import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PageNotFoundComponent } from './errors/page-not-found/page-not-found.component';
import { GenericErrorComponent } from './errors/generic-error/generic-error.component';
import { LoginComponent } from './public/login/login.component';
import { AuthGuard } from './guards/auth.guard';
import { LogoutComponent } from './public/logout/logout.component';
import { ForgotPasswordComponent } from './public/forgot-password/forgot-password.component';

// NOTE on routing structure:
// Routes was structured this way (public/main) so that we don't have to load the whole system's module
// when user is just about to login.

const routes: Routes = [
  {
    path: '',
    redirectTo: 'main',
    pathMatch: 'full',
  },
  {
    path: 'main',
    canActivate: [AuthGuard],
    canLoad: [AuthGuard],
    loadChildren: './main/main.module#MainModule'
  },
  {
    path: 'login',
    redirectTo: 'public/login',
    pathMatch: 'full',
  },
  {
    path: 'public/login',
    component: LoginComponent,
  },
  {
    path: 'public/forgot-password',
    component: ForgotPasswordComponent,
  },
  {
    path: 'logout',
    redirectTo: 'public/logout',
    pathMatch: 'full',
  },
  {
    path: 'public/logout',
    component: LogoutComponent,
  },
  {
    path: 'error',
    component: GenericErrorComponent,
  },
  {
    path: 'error-404',
    component: PageNotFoundComponent,
  },
  {
    path: '**',
    component: PageNotFoundComponent,
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
